export default "__VITE_ASSET__CKBYHQ5v__"